<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">
  <div style="padding-top: 4vh; height: 100%; width: 85%; margin: auto">

    <div class="row deviceSection">
      <div class="deviceHeader">
        <h1 class="centerVert textXXM">{{this.localiser.get("menu.zones")}}</h1>
      </div>
      <div class="deviceTable">
        <table style="width:100%">
          <tr class="bottom-border">
            <th class="textS+">{{this.localiser.get("devices.edit")}}</th>
            <th class="textS+">{{this.localiser.get("devices.name")}}</th>
            <th class="textS+">{{this.localiser.get("devices.floorplan")}}</th>
            <th class="textS+">{{this.localiser.get("zones.numberLuminaries")}}</th>
            <th class="textS+">{{this.localiser.get("zones.numberSensors")}}</th>
            <th></th>
            <th></th>
          </tr>
          <tr *ngFor="let zona of zonas">
            <td>
                <span (click)="editZone(zona)" class="material-icons-outlined textXM" style="cursor: pointer">edit</span>
            </td>
            <td class="textS+">{{zona.nombre}}</td>
            <td class="textS+">{{getPlanoNameByID(zona.idPlano)}}</td>
            <td *ngIf="!luminariasAdded" class="textS+">
              <mat-progress-spinner style="text-align: center;" mode="indeterminate" diameter="20"></mat-progress-spinner>
            </td>
            <td *ngIf="luminariasAdded && zona.luminarias != undefined" class="textS+">{{zona.luminarias.length}}</td>
            <td *ngIf="luminariasAdded && zona.luminarias == undefined" class="textS+">0</td>
            <td *ngIf="!sensoresAdded" class="textS+">
              <mat-progress-spinner style="text-align: center;" mode="indeterminate" diameter="20"></mat-progress-spinner>
            </td>
            <td *ngIf="sensoresAdded && zona.sensores != undefined" class="textS+">{{zona.sensores.length}}</td>
            <td *ngIf="sensoresAdded && zona.sensores == undefined" class="textS+">0</td>
            <td>
              <span (click)="infoZone(zona)" class="material-icons-outlined textXM verticalAlign" style="cursor: pointer">info</span>
              <span *ngIf="user.getPermiso() != Roles.Ateneo" (click)="deleteZone(zona)" class="material-icons-outlined textXM deleteIcon verticalAlign">delete</span>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="row">
      <div *ngIf="user.getPermiso() != Roles.Ateneo" class="col-2" style="margin-top: 2vh; position: absolute">
        <button (click)="newZone()" class="buttonNewZone textS+">{{this.localiser.get("zones.newZone")}}</button>
      </div>

      <div class="paginationDiv">
        <div class="row" style="width: 70%; display: contents">
          <div class="col" style="padding: 0">
              <span (click)="changePageByArrow(-1)" class="material-icons-outlined textXM centerVert cursorPointer navigateBefore"
                    [ngClass]="{disabled: actualPage == 1}">
                navigate_before
              </span>
          </div>
          <div class="col" style="padding: 0">
            <input type="number" class="inputPagination textXM centerVert" [(ngModel)]="this.actualPage" (ngModelChange)="changePageByNumber($event)"
                   (change)="outInputChangePageByNumber($event)">
          </div>
          <div class="col" style="padding: 0">
              <span (click)="changePageByArrow(1)" class="material-icons-outlined textXM centerVert cursorPointer navigateAfter"
                    [ngClass]="{disabled: isLastPage()}">
                navigate_next
              </span>
          </div>
        </div>
      </div>

    </div>

    <div class="row" *ngIf="loadingZonas">
      <mat-progress-spinner style="margin: 1vh auto; text-align: center;" mode="indeterminate" diameter="40"></mat-progress-spinner>
    </div>


  </div>

</div>
